import React from 'react';
import './_Styles.scss';

export default function Loader(props) {
  const {width = '40px', style: propsStyle = {}} = props;
  const style = {
    width,
    height: width,
    ...propsStyle,
  };

  return <div className="loader" style={style}></div>;
}
